import billingV1Client from '../infrastructure/acerill/billing-v1-client';

let subscriptionsPromise = null;

const updateSubscription = (productCode, planCode, frequency) => {
  subscriptionsPromise = null;
  return billingV1Client.updateSubscription(productCode, planCode, frequency);
};

const findSubscriptions = () => {
  if (!subscriptionsPromise) {
    subscriptionsPromise = billingV1Client.findSubscriptions();
  }
  return subscriptionsPromise;
};

const findCurrentSubscription = () => {
  return findSubscriptions()
    .then(subscriptions => {
      if (!subscriptions || subscriptions.length === 0) {
        return {planCode: 'FREE', frequency: null};
      } else {
        const subscription = subscriptions[0];
        return {planCode: subscription.planCode, frequency: subscription.frequency};
      }
    });
}

const subscriptionService = {
  updateSubscription,
  findCurrentSubscription,
};

export default subscriptionService;
